// extracted by mini-css-extract-plugin
module.exports = {"imageTextTriplets":"style_imageTextTriplets__5nNZn","child":"style_child__u-iy9","image":"style_image__wcIwr","paragraphGroup":"style_paragraphGroup__3Zwhs"};